import { defineMessages, useIntl } from "react-intl";
import { classNames } from "@ct-react/core";
import { SkeletonableProps } from "../../tools/components";
import "./room-layout.scss";

const transDefs = defineMessages({
  title: { id: "article.rubrics.room-layout", defaultMessage: "Disposition des chambres" },
});

type Props = SkeletonableProps<any>;

const RoomLayoutPart = ({ className, loading, data }: Props) => {

  const intl = useIntl();
  const wrapperClasses = classNames("rooms-part", className);

  if (loading || !data)
    return null;

  return (
    <div className={wrapperClasses}>
      <h2>{intl.formatMessage(transDefs.title)}</h2>
      <div className="scroll-flow">
        <div className="content">
          {data.map(({ name, contents }: any, i: number) => (
            <div key={i} className="item">
              <h3>{name.value}</h3>
              <ul>{contents.map(({ value }: any, j: number) => <li key={j}>{value}</li>)}</ul>
            </div>))}
        </div>
      </div>
    </div>);

}

export default RoomLayoutPart;
